import { z } from 'zod'

export const percentageNumber = z
  .number()
  .int()
  .min(0, 'Percentage cannot be negative')
  .max(100, 'Percentage cannot exceed 100')
  .nullable()
  .optional()

export const parseRequiredNumber = (value: string | number): number => {
  return typeof value === 'string' ? Number(value) : value
}

/*
const positiveNumber = z.number().positive('Value must be positive').nullable().optional()

const nonNegativeNumber = z.number().min(0, 'Value cannot be negative').nullable().optional()

const isNullable = <T>(value: T | null | undefined): T | null => {
  return value === undefined || value === null ? null : value
}
*/
